import clsx from 'clsx';
import React from 'react';
import type { Eintragung } from 'types/eintragungen';
import { useMinimalUserInteraction, useTranslation } from 'utils/hooks';

import css from './BlurredEintragungenlist.module.scss';

interface ScheinunternehmenEintragungenListProps 
{
  eintragungen: Eintragung[];
}

const BlurredEintragungenList: React.FC<ScheinunternehmenEintragungenListProps> = (props) => 
{
  const { eintragungen } = props;
  const { t } = useTranslation();
  const mui = useMinimalUserInteraction();

  const columns = [
    t('eintragungen:table.name'),
    t('eintragungen:table.bundesland'),
    t('formats:date', { value: eintragungen[0].datum }),
  ];

  const renderRow = (eintragung: Eintragung) =>
    (<tr key={eintragung.fbNr}>
      <td className="">
        {t('formats:nameWithFbNr', { name: eintragung.name, fbNr: eintragung.fbNr })}
      </td>
      <td>{t(`bundesländer:shortList.${eintragung.bundesland}`)}</td>
      <td>{t('formats:date', { value: eintragung.datum })}</td>
    </tr>);

  if (!mui) 
  {
    return null;
  }

  return (
    <table className={clsx(['profileTable', css.blurred])}>
      <thead>
      <tr>
        {columns.map((column) => <th key={column}>{column}</th>)}
      </tr>
      </thead>
      <tbody>
      {eintragungen.map(renderRow)}
      </tbody>
    </table>
  );
};

export default BlurredEintragungenList;
